namespace Matrix.Data {
    export interface DataReportExportRequest extends Serenity.ServiceRequest {
        ReportKey?: string;
        SpreadsheetWorkSessionId?: string;
    }
}
